import React from "react";

const SettlementPreview = ({ settlement }) => {

    if (!settlement) return null;

    return (

        <div className="settlement-preview">

            <h3>Settlement Preview</h3>

            <div className="preview-row">
                <span>Provider</span>
                <strong>{settlement.provider?.businessName}</strong>
            </div>

            <div className="preview-row">
                <span>Total Orders</span>
                <strong>{settlement.totalOrders}</strong>
            </div>

            <div className="preview-row">
                <span>Total Revenue</span>
                <strong>₹{settlement.totalRevenue}</strong>
            </div>

            <div className="preview-row">
                <span>Commission</span>
                <strong>₹{settlement.commission}</strong>
            </div>

            <div className="preview-row">
                <span>Taxes</span>
                <strong>₹{settlement.taxes}</strong>
            </div>

            <div className="preview-row">
                <span>Payable Amount</span>
                <strong>₹{settlement.payableAmount}</strong>
            </div>

        </div>

    );

};

export default SettlementPreview;